// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2HMlj","file":"styles_file__14G0E"};